/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalExport = {
    file_type: b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalExport.file_type;
    proposal_ids: string;
    risk_period?: number;
};
export namespace b2b_v1_portfolio_builder_portfolio_proposal_PortfolioProposalExport {
    export enum file_type {
        PDF = 'pdf',
        XLSX = 'xlsx',
    }
}

